// extracted by mini-css-extract-plugin
export var intrestsDiv = "IntrestLinks-module--intrestsDiv--d6675";
export var links = "IntrestLinks-module--links--5e8ce";
export var list = "IntrestLinks-module--list--d8d45";